import { Asset, HelpIcon, Tooltip } from '@clearcover/atlas';
import { useFormikContext } from 'formik';
import {
  AdvancedVehicleFeatureType,
  VehicleADASFeaturesType,
} from 'QuoteApp/services/endpoints/GetDetails';
import { getFieldErrors } from 'QuoteApp/utils';
import React, { FC, useCallback } from 'react';
import { Column, FormInput, Row } from 'Shared/components';
import styles from './styles.module.css';

export const AdvancedFeatureInput: FC<{
  feature: AdvancedVehicleFeatureType;
  vehicleName: string;
  vehicleId: string;
}> = ({ feature, vehicleName, vehicleId }) => {
  const {
    setFieldValue,
    values,
    errors,
    touched,
    initialValues,
  } = useFormikContext<VehicleADASFeaturesType>();

  const featureTestId = `${vehicleName
    .toLowerCase()
    .replace(/ /g, '-')}-${feature.featureGroup
    .toLowerCase()
    .replace(/ /g, '-')}`;

  const getFullFieldName = useCallback(
    (fieldName: AdvancedVehicleFeatureType['featureDataName']) =>
      `vehicles.${vehicleId}.${fieldName}`,
    [vehicleId]
  );
  const fullFieldName = getFullFieldName(feature.featureDataName);

  return (
    <div className={styles.featureContent}>
      <div className={styles.featureTitle}>
        <span className={styles.featureName}>{feature.featureGroup}</span>
        <Tooltip tooltip={feature.toolTipText} position="bottom">
          <Asset
            icon={HelpIcon}
            description={`${feature.featureGroup} Information`}
            height={19}
            width={19}
            className={styles.helpIcon}
          />
        </Tooltip>
      </div>
      <div className={styles.featureTypes}>
        {feature.subCategories.map(category => (
          <div
            className={styles.subFeature}
            key={`${vehicleName}-${feature.featureGroup}-${category}`}
          >
            {category}
          </div>
        ))}
      </div>
      <div className={styles.featureToggle}>
        <Row>
          <Column variant="third">
            <FormInput
              name={fullFieldName}
              value={values.vehicles[vehicleId][feature.featureDataName]}
              errorMessage={getFieldErrors(
                fullFieldName,
                true,
                false,
                errors,
                {},
                values,
                touched,
                initialValues
              )}
              variant="radioButtonGroup"
              data-testid={featureTestId}
              className="adas-feature-toggle"
              label="Are any of these features installed?"
              onChange={(value: string) => {
                setFieldValue(getFullFieldName(feature.featureDataName), value);
              }}
              options={{ yes: 'Yes', no: 'No' }}
            />
          </Column>
        </Row>
      </div>
    </div>
  );
};
